import { Button } from 'components/core';
import { fieldsOf } from 'constants/kpiBuilderCatalogue';
import { CustomBucket } from 'helpers/kpiBuilder/types';
import { BuilderSection } from './BuilderSection';
import { FilterRow } from './FilterRow';
import { StepProps } from './StepProps';
import { TextBox } from './TextBox';
import { OUTLINE_SMALL } from './buttonProps';

const blank = (): CustomBucket => ({ label: '', when: { field: '', op: 'is', value: '', value2: '' } });

// More bars next to the first two, each with its own name and condition.
export const ExtraSeriesStep = ({ a, patch }: StepProps) => {
  const series = a.custom.extraSeries;
  const save = (next: CustomBucket[]) => patch({ custom: { ...a.custom, extraSeries: next } });
  const set = (i: number, next: Partial<CustomBucket>) => save(series.map((b, j) => (j === i ? { ...b, ...next } : b)));

  return (
    <BuilderSection title="More bars (optional)" hint="Add another bar per group, with its own name and condition, for example “Reattempted” where attempt number is more than 1. Each bar counts only the records that meet its condition.">
      {series.map((b, i) => (
        <div key={i} className="border rounded p-2 mb-2 bg-white">
          <TextBox value={b.label} placeholder="Bar name, e.g. Reattempted" onChange={(label) => set(i, { label })} />
          <div className="mt-1">
            <FilterRow filter={b.when} fields={fieldsOf(a.src)} onChange={(when) => set(i, { when })} />
          </div>
          <Button {...OUTLINE_SMALL} onClick={() => save(series.filter((_, j) => j !== i))}>
            Remove bar
          </Button>
        </div>
      ))}
      <Button {...OUTLINE_SMALL} onClick={() => save([...series, blank()])}>
        Add a bar
      </Button>
    </BuilderSection>
  );
};
